import React from 'react'
import { Link } from 'react-router-dom'
import useScrollTo from '../hooks/useScrollTo'
import './Footer.css'

const Footer = () => {
  const scrollToSection = useScrollTo()

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="wrapper">
          <div className="footer-grid">
            <div className="footer-section footer-logo">
              <div className="gb-logo"></div>
            </div>

            <div className="footer-section">
              <h3>
                <a href="/about#contact" className="gray" onClick={(e) => { e.preventDefault(); scrollToSection('contact', '/about') }}>Contact</a>
              </h3>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="icon-phone"></span>
                  <p>+86-010-65157574</p>
                </div>
                <div className="contact-item">
                  <span className="icon-email"></span>
                  <p>info@goldenbridges.org</p>
                </div>
                <div className="contact-item">
                  <span className="icon-address"></span>
                  <p>
                    No.65 Xiaojingchang Hutong, Guloudong Ave,<br />
                    Dongcheng District, Beijing 100009<br />
                    <a href="/about#contact" className="yellow" onClick={(e) => { e.preventDefault(); scrollToSection('contact', '/about') }}>
                      GET MAP
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="footer-section">
              <h3>
                <a href="/about#mission" className="gray" onClick={(e) => { e.preventDefault(); scrollToSection('mission', '/about') }}>About</a>
              </h3>
              <ul className="footer-links">
                <li><a href="/about#mission" onClick={(e) => { e.preventDefault(); scrollToSection('mission', '/about') }}>Mission</a></li>
                <li><a href="/about#history" onClick={(e) => { e.preventDefault(); scrollToSection('history', '/about') }}>History</a></li>
                <li><a href="/about#founder" onClick={(e) => { e.preventDefault(); scrollToSection('founder', '/about') }}>Founder</a></li>
                <li><a href="/about#values" onClick={(e) => { e.preventDefault(); scrollToSection('values', '/about') }}>Golden Rules</a></li>
                <li><a href="/about#team" onClick={(e) => { e.preventDefault(); scrollToSection('team', '/about') }}>Team</a></li>
                <li><a href="/about#financials" onClick={(e) => { e.preventDefault(); scrollToSection('financials', '/about') }}>Financials</a></li>
                <li><a href="/about#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact', '/about') }}>Contact Us</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>
                <a href="#programs" className="gray" onClick={() => scrollToSection('programs')}>
                  Featured Programs
                </a>
              </h3>
              <ul className="footer-links">
                <li>
                  <a href="http://projectpengyou.org" target="_blank" rel="noopener noreferrer">
                    Project Pengyou
                  </a>
                </li>
                <li><a href="#thechinafoundationcenter">China Foundation Center</a></li>
                <li><a href="#thegreatgreeninitiative">The Great Green Initiative</a></li>
                <li><a href="#fivebuckets">The "Five Bucket" Model</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="wrapper">
          <div className="site-info text-center">
            Golden Bridges Foundation (EIN: 26-1559010) Copyright 2007-{new Date().getFullYear()} All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer